export default {
  solutionExchangeRates: [],
  solutionExchangeRate: undefined,
};
